import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import icons from "../../../assets/data/priceDetailsIcons";
import classes from "./expandablesec.module.css";

function ExpandableSection(props) {
  return (
    <details className={classes.wrapper}>
      <summary className={classes.sectionTitle}>
        {icons[props.icon] && props.aux != true && (
          <img src={icons[props.icon]} alt="icon" className={classes.icon} />
        )}
        <div className={classes.sectionName}>{props.title}</div>
        <ExpandMoreIcon
          className={classes.expandIcon}
          sx={{ fontSize: "4rem" }}
        />
      </summary>
      <ul className={classes.content}>
        {props.text.map((content) => (
          <>
            <p dangerouslySetInnerHTML={{ __html: content }}></p>
          </>
        ))}
      </ul>
    </details>
  );
}

export default ExpandableSection;
